import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_BY_CID_CODE: 'fetchByCidCode',
  FETCH_ALL_CID_CODE: 'fetchAllCidCode'
}

export const globalActions = getNamespacedBy('cid', actionTypes)
